export default [
  {
    path: '/',
    name: 'sports-mode-wrapper',
    children: [
      {
        path: 'statistics',
        name: 'statistics',
        component: () => import(/* webpackChunkName: 'statistics-widget' */ '../../widgets/statistics/StatisticsWidget.vue')
      },
      {
        path: 'standings',
        name: 'standings',
        component: () => import(/* webpackChunkName: 'standings-widget' */ '../../widgets/standings/StandingsWidget.vue')
      },
      {
        path: 'scoreboard',
        name: 'scoreboard',
        component: () => import(/* webpackChunkName: 'scorebaord-widget' */ '../../widgets/scoreboard/ScoreboardWidget.vue')
      },
      {
        path: 'fixtures',
        name: 'fixtures',
        component: () => import(/* webpackChunkName: 'fixtures-widget' */ '../../widgets/fixtures/FixturesWidget.vue')
      },
      {
        path: 'player-profile',
        name: 'playerProfileOld',
        component: () => import(/* webpackChunkName: 'playerProfileOld-widget' */ '../../widgets/playerProfile/PlayerProfileWidget.vue')
      },
      {
        path: 'team-profile',
        name: 'teamProfile',
        component: () => import(/* webpackChunkName: 'teamProfile-widget' */ '../../widgets/teamProfile/TeamProfileWidget.vue')
      },
      {
        path: 'team-lineup',
        name: 'teamLineup',
        component: () => import(/* webpackChunkName: 'teamsLineup-widget' */ '../../widgets/teamsLineup/TeamsLineupWidget.vue'),
        props: {
          eventId: 'sr:sport_event:50850509',
          teamId: 'sr:competitor:38'
        }
      },
      {
        path: 'teams-lineup',
        name: 'teamsLineup',
        component: () => import(/* webpackChunkName: 'teamsLineup-widget' */ '../../widgets/teamsLineup/TeamsLineupWidget.vue')
      },
      {
        path: 'events-stripe',
        name: 'eventsStripe',
        component: () => import(/* webpackChunkName: 'teamsLineup-widget' */ '../../widgets/stripe-legacy/Stripe.vue')
      },
      {
        path: 'events-stripe-v2',
        name: 'eventsStripeV2',
        component: () => import(/* webpackChunkName: 'teamsLineup-widget' */ '../../widgets/stripe/Stripe.vue')
      },
      {
        path: 'knockout',
        name: 'knockout',
        component: () => import(/* webpackChunkName: 'knockout-widget' */ '../../widgets/knockout/Knockout.vue')
      },
      {
        path: 'basketball',
        children: [
          {
            path: 'scoreboard',
            name: 'basketballScoreboard',
            component: () => import(/* webpackChunkName: 'basketballScoreboard-widget' */ '../../widgets/scoreboard/Basketball.vue')
          },
          {
            path: 'boxscore',
            name: 'basketballBoxscore',
            component: () => import(/* webpackChunkName: 'basketballBoxscore-widget' */ '../../widgets/boxscore/BasketballBoxscoreWidget.vue')
          },
          {
            path: 'roster',
            name: 'basketballRoster',
            component: () => import(/* webpackChunkName: 'basketballRoster-widget' */ '../../widgets/roster/BasketballRoster.vue')
          },
          {
            path: 'statistics',
            name: 'basketballStatistics',
            component: () => import(/* webpackChunkName: 'basketballTimeline-widget' */ '../../widgets/statistics/BasketballStatistics.vue')
          },
          {
            path: 'fixtures',
            name: 'basketballFixtures',
            component: () => import(/* webpackChunkName: 'basketballFixtures-widget' */ '../../widgets/fixtures/BasketballFixtures.vue')
          },
          {
            path: 'standings',
            name: 'basketballStandings',
            component: () => import(/* webpackChunkName: 'basketballStandings-widget' */ '../../widgets/standings/BasketballStandings.vue')
          },
          {
            path: 'player-profile',
            name: 'basketballPlayerProfile',
            component: () => import(/* webpackChunkName: 'basketballPlayerProfile-widget' */ '../../widgets/playerProfile/BasketballPlayerProfile.vue')
          },
          {
            path: 'team-profile',
            name: 'basketballTeamProfile',
            component: () => import(/* webpackChunkName: 'basketballTeamProfile-widget' */ '../../widgets/teamProfile/BasketballTeamProfile.vue')
          },
          {
            path: 'knockout',
            name: 'basketballKnockout',
            component: () => import(/* webpackChunkName: 'basketballKnockout-widget' */ '../../widgets/knockout/BasketballKnockout.vue')
          },
          {
            path: 'euroleague',
            name: 'euroleagueBasketball',
            children: [
              {
                path: 'player-profile',
                name: 'euroleaguePlayerProfile',
                component: () => import(/* webpackChunkName: 'euroleaguePlayerProfile-widget' */ '../../widgets/euroleague/player-profile/PlayerProfile.vue')
              },
              {
                path: 'roster',
                name: 'euroleagueRoster',
                component: () => import(/* webpackChunkName: 'euroleagueRoster-widget' */ '../../widgets/euroleague/roster/Roster.vue')
              },
              {
                path: 'boxscore',
                name: 'euroleagueBoxscore',
                component: () => import(/* webpackChunkName: 'euroleagueBoxscore-widget' */ '../../widgets/euroleague/boxscore/Boxscore.vue')
              },
              {
                path: 'statistics',
                name: 'euroleagueStatistics',
                component: () => import(/* webpackChunkName: 'euroleagueStatistics-widget' */ '../../widgets/euroleague/statistics/Statistics.vue')
              },
              {
                path: 'fixtures',
                name: 'euroleagueFixtures',
                component: () => import(/* webpackChunkName: 'euroleagueFixtures-widget' */ '../../widgets/euroleague/fixtures/FixturesWidget.vue')
              },
              {
                path: 'team-profile',
                name: 'euroleagueTeamProfile',
                component: () => import(/* webpackChunkName: 'euroleagueTeamProfile-widget' */ '../../widgets/euroleague/team-profile/TeamProfile.vue')
              },
              {
                path: 'standings',
                name: 'euroleagueStandings',
                component: () => import(/* webpackChunkName: 'euroleagueStandings-widget' */ '../../widgets/standings/BasketballStandings.vue')
              },
              {
                path: 'player-leaderboard',
                name: 'euroleaguePlayerLeaderboard',
                component: () => import(/* webpackChunkName: 'euroleaguePlayerLeaderboard-widget' */ '../../widgets/euroleague/leaderboard/Leaderboard.vue'),
                props: {
                  leaderboardType: 'player'
                }
              },
              {
                path: 'team-leaderboard',
                name: 'euroleagueTeamLeaderboard',
                component: () => import(/* webpackChunkName: 'euroleagueTeamLeaderboard-widget' */ '../../widgets/euroleague/leaderboard/Leaderboard.vue'),
                props: {
                  leaderboardType: 'team'
                }
              },
              {
                path: 'play-by-play',
                name: 'euroleaguePlayByPlay',
                component: () => import(/* webpackChunkName: 'euroleaguePlayByPlay-widget' */ '../../widgets/euroleague/play-by-play/PlayByPlay.vue')
              }
            ]
          }
        ]
      },
      {
        path: 'tennis',
        children: [
          {
            path: 'rankings',
            name: 'rankings',
            component: () => import(/* webpackChunkName: 'rankings-widget' */ '../../widgets/rankings/RankingsWidget.vue')
          },
          {
            path: 'player-profile',
            name: 'tennisPlayerProfile',
            component: () => import(/* webpackChunkName: 'tennisPlayerProfile-widget' */ '../../widgets/playerProfile/TennisPlayerProfile.vue')
          },
          {
            path: 'statistics',
            name: 'tennisStatistics',
            component: () => import(/* webpackChunkName: 'tennisStatistics-widget' */ '../../widgets/tennis-statistics/Statistics.vue')
          },
          {
            path: 'fixtures',
            name: 'tennisFixtures',
            component: () => import(/* webpackChunkName: 'tennisFixtures-widget' */ '../../widgets/fixtures/TennisFixtures.vue')
          },
          {
            path: 'knockout',
            name: 'tennisKnockout',
            component: () => import(/* webpackChunkName: 'tennisKnockout-widget' */ '../../widgets/knockout/TennisKnockout.vue')
          }
        ]
      },
      {
        path: 'live-score',
        name: 'LiveScoreboard',
        component: () => import(/* webpackChunkName: 'livescore-widget' */ '../../widgets/livescore/LiveScoreboard.widget.vue')
      },
      {
        path: 'live-score-euroleague',
        name: 'LiveScoreboardEuroleague',
        component: () => import(/* webpackChunkName: 'livescore-euroleague-widget' */ '../../widgets/livescore/LiveScoreboard.widget.vue')
      },
      {
        path: 'match-commentary',
        name: 'MatchCommentary',
        component: () => import(/* webpackChunkName: 'match-commentary-widget' */ '../../widgets/match-commentary/MatchCommentary.widget.vue')
      },
      {
        path: 'v1.5',
        children: [
          {
            path: 'knockout',
            name: 'knockoutRedesign',
            component: () => import(/* webpackChunkName: 'knockoutRedesign-widget' */ '../../widgets/knockout/Knockout.vue')
          },
          {
            path: 'match-summary',
            name: 'MatchSummary',
            component: () => import(/* webpackChunkName: 'match-summary-widget' */ '../../__v1.5__/widgets/match-summary/MatchSummary.vue')
          },
          {
            path: 'key-moments',
            name: 'key-moments',
            component: () => import(/* webpackChunkName: 'statistics-widget' */ '../../__v1.5__/widgets/match-summary/MatchSummary.vue'),
            props: {
              tabs: [{ id: 'moment', name: 'Key Moments', labelKey: 'statistics_key_moments', icon: 'key-moments' }]
            }
          },
          {
            path: 'game-stats',
            name: 'game-stats',
            component: () => import(/* webpackChunkName: 'statistics-widget' */ '../../__v1.5__/widgets/match-summary/MatchSummary.vue'),
            props: {
              tabs: [{ id: 'stat', name: 'Game Stats', labelKey: 'statistics_game_stats', icon: 'game-statistics' }]
            }
          },
          {
            path: 'leaderboard',
            name: 'leaderboard',
            component: () => import(/* webpackChunkName: 'leaderboard-widget' */ '../../__v1.5__/widgets/leaderboard/Leaderboard.vue')
          },
          {
            path: 'standings',
            name: 'standings',
            component: () => import(/* webpackChunkName: 'standings-widget' */ '../../__v1.5__/widgets/standings/Standings.vue')
          },
          {
            path: 'player-profile',
            name: 'playerProfile',
            component: () => import(/* webpackChunkName: 'playerProfile-widget' */ '../../__v1.5__/widgets/playerProfile/PlayerProfile.vue')
          },
          {
            path: 'fixtures',
            name: 'fixtures',
            component: () => import(/* webpackChunkName: 'fixtures-widget' */ '../../__v1.5__/widgets/fixtures/Fixtures.vue')
          },
          {
            path: 'team-profile',
            name: 'team-profile-v1.5',
            component: () => import(/* webpackChunkName: 'team-profile-v1.5-widget' */ '../../__v1.5__/widgets/teamProfile/TeamProfile.vue')
          }
        ]
      }
    ]
  }
]
